module.exports = __webpack_public_path__ + "img/featured-women-s-weekly.c133cdc3.png";